import React, { useState } from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import "./RadioButton.scss";

interface RadioButtonProps {
  options: string[];
  defaultSelected?: string; 
}

function RadioButton({ options, defaultSelected }: RadioButtonProps) {
 const [alignment, setAlignment] = useState(defaultSelected || "");

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    setAlignment(newAlignment);
  };

  return (
    <Box className="radio_button">
      <Grid container spacing={3}>
        <Grid xs={12}>
          <ToggleButtonGroup
            value={alignment}
            exclusive
            onChange={handleChange}
            aria-label="Platform"
          >
            {options.map((option) => (
              <ToggleButton key={option} value={option}>
                {option}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Grid>
      </Grid>
    </Box>
  );
}

export default RadioButton;
